import {Grid} from '@mui/material';
import React, {useEffect} from 'react';
import {useParams} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import {makeLocationSelector} from '../../selector/locationsSelector';
import {fetchLocations} from '../../action/locationsCommands';
import {Location} from '../../api/types';
import LocationInfo from './LocationInfo';

const LocationDetailsPage = () => {
    const dispatch = useDispatch();
    const params = useParams<{ locationId: string }>();
    const locationId = params.locationId || '';
    const location: Location|undefined = useSelector(makeLocationSelector(locationId));

    useEffect(() => {
        if (!location) {
            dispatch(fetchLocations({}));
        }
    }, []);

    if (!location) {
        return null;
    }

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} md={6}>
                <LocationInfo location={location} />
            </Grid>
        </Grid>
    );
};

export default LocationDetailsPage;
